"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MainNavBars_1 = __importDefault(require("./MainNavBars"));
exports.default = MainNavBars_1.default;
